var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.WhiteliRtroutes.includes(_vm.$route.path)||_vm.WhiteliRtrouteName.includes(_vm.$route.name))?[_c('router-view')]:[_c('IndexComponent')],_c('CookieConsentBanner'),(_vm.showPreferences)?_c('CookiePreferencesModal',{attrs:{"visible":_vm.showPreferences},on:{"close":_vm.closePreferences}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }